import { IScope, IAugmentedJQuery, IAttributes } from "angular";

export class PaginationControlDirective {
    public restrict = "AE";
    public link: (scope: IScope, element: IAugmentedJQuery, attrs: IAttributes) => void;
    public scope = false;
    public templateUrl = "ranking-pagination/pagination-control.html";

    public static instance() {
        let directive = () => {
            return new PaginationControlDirective();
        };

        directive["$inject"] = [];

        return directive;
    }
}
